
import { DashboardStats } from "@/components/dashboard/DashboardStats";
import { RecentActivity } from "@/components/dashboard/RecentActivity";
import { UpcomingEventsWidget } from "@/components/dashboard/UpcomingEventsWidget";
import { SuggestedActivitiesWidget } from "@/components/dashboard/SuggestedActivitiesWidget";
import { useAuth } from "@/contexts/AuthContext";

const Dashboard = () => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-xl font-semibold mb-2">Authentication Required</h2>
          <p className="text-muted-foreground">Please sign in to access the dashboard.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex-1 space-y-4 p-4 md:p-8 pt-6">
      <div className="flex items-center justify-between space-y-2">
        <h2 className="text-3xl font-bold tracking-tight">
          Welcome back, {user.user_metadata?.first_name || user.email?.split('@')[0] || 'User'}!
        </h2>
      </div>
      
      <DashboardStats />
      
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-7">
        <div className="col-span-4">
          <SuggestedActivitiesWidget />
        </div>
        <div className="col-span-3">
          <UpcomingEventsWidget />
        </div>
      </div>
      
      <RecentActivity />
    </div>
  );
};

export default Dashboard;
